<div class="landing-page" [attr.lang]="language" #top>
  <header class="site-header">
    <nav class="page-shell site-nav" [attr.aria-label]="'home' | translate">
      <button class="brand-button" type="button" (click)="scrollSmooth(topElement)"
              [attr.aria-label]="'electronic registration' | translate">
        <img src="./assets/images/logos/tranrevisjon.png" alt="" />
      </button>
      <div class="header-actions">
        <app-language-dropdown appearance="landing" />
        <button class="primary-button login-button" type="button" (click)="navigateLogin()">
          {{ 'sign in' | translate }}
        </button>
      </div>
    </nav>
  </header>

  <main>
    <section class="page-shell hero-section">
      <div class="hero-copy">
        <h1><span>{{ 'welcome to' | translate }}</span> {{ 'electronic registration' | translate }}</h1>
        <p>{{ 'landing hero description' | translate }}</p>
        <button class="primary-button hero-button" type="button" (click)="scrollSmooth(registerElement)">
          {{ 'create account' | translate }}
        </button>
      </div>
      <div class="hero-image" role="img" [attr.aria-label]="'halden harbour image' | translate"></div>
    </section>

    <section class="mission-section">
      <div class="page-shell mission-grid">
        <article>
          <h2>{{ 'our mission' | translate }}</h2>
          <p>{{ 'landing mission description' | translate }}</p>
        </article>
        <article>
          <h2>{{ 'our vision' | translate }}</h2>
          <p>{{ 'landing vision description' | translate }}</p>
        </article>
      </div>
    </section>

    <section class="register-section" id="register" #registration>
      <div class="page-shell register-grid">
        <div class="register-intro">
          <div>
            <h2>{{ 'landing registration title' | translate }}</h2>
            <p>{{ 'landing registration description' | translate }}</p>
          </div>
          <div class="next-steps">
            <h3>{{ 'what happens next' | translate }}</h3>
            <ol>
              @for (step of registrationSteps; track step.title; let index = $index) {
                <li>
                  <span class="step-number">{{ index + 1 }}</span>
                  <div>
                    <strong>{{ step.title | translate }}</strong>
                    <p>{{ step.description | translate }}</p>
                  </div>
                </li>
              }
            </ol>
          </div>
        </div>

        <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()"
              [attr.aria-label]="'landing registration title' | translate">
          <div class="form-grid">
            @for (field of inputFields; track field.name) {
              <div class="form-field">
                <label [for]="field.name">{{ field.label | translate }} <span aria-hidden="true">*</span></label>
                <input [id]="field.name" [formControlName]="field.name" [type]="field.type"
                       [autocomplete]="field.autocomplete" [attr.inputmode]="field.inputmode"
                       aria-required="true" [attr.aria-describedby]="field.name + '-error'"
                       [attr.aria-invalid]="controls[field.name].touched && controls[field.name].invalid"
                       [class.invalid]="controls[field.name].touched && controls[field.name].invalid" />
                <div class="error-container" [id]="field.name + '-error'" aria-live="polite">
                  @if (fieldError(field.name, field.label); as error) {
                    <span>{{ error | translate }}</span>
                  }
                </div>
              </div>
            }
          </div>

          <div class="form-field">
            <label for="message">{{ 'message' | translate }}</label>
            <textarea id="message" formControlName="message" rows="3"
                      aria-describedby="message-error"
                      [attr.aria-invalid]="controls['message'].touched && controls['message'].invalid"
                      [class.invalid]="controls['message'].touched && controls['message'].invalid"></textarea>
            <div class="error-container" id="message-error" aria-live="polite">
              @if (fieldError('message', 'message'); as error) {
                <span>{{ error | translate }}</span>
              }
            </div>
          </div>

          <div class="form-actions">
            <div class="captcha-shell">
              <app-captcha [inputChange]="onCaptchaInputChange" appearance="landing" />
            </div>
            <button
              class="primary-button submit-button"
              type="submit"
              [disabled]="isSubmitting"
              [attr.aria-busy]="isSubmitting">
              @if (isSubmitting) {
                <span class="button-spinner" aria-hidden="true"></span>
              }
              <span>{{ 'submit' | translate }}</span>
              @if (!isSubmitting) {
                <i-tabler name="arrow-right" />
              }
            </button>
          </div>
        </form>
      </div>
    </section>

    <section class="contact-section" #contactSection>
      <div class="page-shell contact-grid">
        <div>
          <h2>{{ 'contact us' | translate }}</h2>
          <p>{{ 'landing contact description' | translate }} <strong>Trung Tran</strong>.</p>
        </div>
        <div class="contact-links">
          <a href="tel:91626505"><i-tabler name="phone" /><span>916 26 505</span></a>
          <a href="mailto:trung.tran@trancorp.no"><i-tabler name="mail" /><span>trung.tran&#64;trancorp.no</span></a>
          <span><i-tabler name="map-pin" /><span>Repslagergata 8, 1776 Halden, Norway</span></span>
        </div>
      </div>
    </section>
  </main>

  <footer class="site-footer">
    <div class="page-shell footer-content">
      <span>© {{ currentYear }} Transoft AS</span>
    </div>
  </footer>
  @if (showScrollToTop()) {
    <button class="scroll-top-button" type="button" (click)="scrollSmooth(topElement)"
            [attr.aria-label]="'scroll to top' | translate">
      <i-tabler name="arrow-up" />
    </button>
  }
</div>
